import { Routes } from '@angular/router';
import { ConsumerLeadRegistration } from './components/consumer-lead-registration/consumer-lead-registration.component';
import { PersonalAssistantRegistration } from './components/personal-assistant-registration/personal-assistant-registration.component';
import { ParticipantInformationComponent } from './components/leads/participant-information/participant-information.component';
import { SummaryComponent } from './components/leads/summary/summary.component';
import { ContactDetailsComponent } from './components/leads/contact-details/contact-details.component';
import { CommPreferenceComponent } from './components/leads/comm-preference/comm-preference.component';
import { NewReferralComponent } from './components/leads/new-referral/new-referral.component';
import { ServiceDetailsComponent } from './components/leads/service-details/service-details.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent
  },
  {
    path: 'consumer-interest/:state',
    component: ConsumerLeadRegistration,
  },
  {
    path: 'provider-interest/:state',
    component: PersonalAssistantRegistration,
  },
  {
    path: 'newReferral',
    component: NewReferralComponent,
    children: [
      { path: '', component: ParticipantInformationComponent },
      { path: 'participant_info', component: ParticipantInformationComponent },
      { path: 'service_details', component: ServiceDetailsComponent },
      { path: 'contact_details', component: ContactDetailsComponent },
      { path: 'comm_preferences', component: CommPreferenceComponent },
      { path: 'summary', component: SummaryComponent },
    ],
  },
];
